module.exports = __webpack_public_path__ + "static/media/Telkosh.1528d050.png";